/**
 * Feature flags for Assagart.
 *
 * Use a single source of truth for in-development / hidden features so we can
 * reintroduce them later without restoring code from git history.
 */
export const FEATURES = {
  // Tokenisation, fractional marketplace, smart contracts, buyback, on-chain
  // provenance, investor FCA certification, web3 wallet connect, DT Vault
  // upgrade. All code retained; user-facing entry points suppressed.
  TOKENISATION_ENABLED: false,
};
